import { useLocation, useNavigate } from 'react-router-dom';
import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import CustomizerContext from '../../_helper/Customizer';
import { addbomasTestLesson, getbomasTestLesson, ModalToggle, isOpenModal, updatebomasTestLesson, statusUpdatebomasTestLesson, isOpenStatusModal, statusToggle, statusDeletebomasTestLesson, } from '../../store/bodmasTestLessonSlice';


const BodmasTestLessonsTable = () => {
  const navigate = useNavigate();
  const storeVar = useSelector(state => state.bodmasTestLesson)
  const { layoutURL } = useContext(CustomizerContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const [mainId, setmainId] = useState('')
  const [lessonType, setlessonType] = useState('')
  const toggle = () => dispatch(ModalToggle());
  const statusModalToggle = () => dispatch(statusToggle());
  const [stateStatus, setStateStatus] = useState('active');
  const [submit, setSubmit] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    title: '',
    lessonId: '',
    duration: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    const type = searchParams.get("type");
    setmainId(id);
    setlessonType(type);
    dispatch(getbomasTestLesson(formVar.limit, formVar.offset, formVar.status, formVar.keyword, id))
  }, [location.search]);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getbomasTestLesson(formVar.limit, offset, formVar.status, formVar.keyword, mainId))
  };
  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }))
    searchWithDelay(e.target.value)
  }
  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getbomasTestLesson(formVar.limit, formVar.offset, formVar.status, keyword, mainId))
    }, typingDelay);
    setTypingTimer(timer);
  };
  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }))
    dispatch(getbomasTestLesson(formVar.limit, formVar.offset, e.target.value, formVar.keyword, mainId))
  };
  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      lessonId: data._id,
      modalTitle: 'Edit Lesson',
      title: data.title,
      duration: data.duration
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Lesson',
      title: '',
      duration: '',
    }))
  }
  const onValueChange = (event) => {
    setStateStatus(event.target.value)
  }

  const submitMenu = () => {
    if (categoryNameValid() || durationValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updatebomasTestLesson(formVar.lessonId, { title: formVar.title, duration: formVar.duration }))
    } else {
      dispatch(addbomasTestLesson({ bodmasTestId: mainId, type: lessonType, title: formVar.title, duration: formVar.duration }))
    }
  }
  const submitStatus = () => {
    dispatch(statusUpdatebomasTestLesson({ id: formVar.lessonId, status: stateStatus }))
  }
  const categoryNameValid = () => {
    if (!formVar.title) {
      return "Name is required";
    }
  }
  const durationValid = () => {
    if (!formVar.duration) {
      return "Name is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeletebomasTestLesson({ id: data._id, status: 'deleted' }))
        }
      });
  }

  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true))
    setStateStatus(data.status)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      lessonId: data._id,
    }))
  }

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
                <Input className="form-control" placeholder='Serch..' type="text" id="yourInputId"
                  value={formVar.keyword} onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="4">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.status} onChange={handleInputChange}>
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Lessons
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Duration</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.bomasTestLessonData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.duration}</td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'DEACTIVE' && <>
                          <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            {item.status === 'DEACTIVE' && (
                              <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            )}
                            &nbsp; <span>{item.status}</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-success action-icon'>
                          <i className="fa fa-question-circle fa-lg" onClick={(e) => navigate('/bodmas-questions/' + layoutURL + '?id=' + item._id)}></i>
                          <div className="tooltipCustom">Questions</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon'>
                          <i className="fa fa-toggle-on fa-lg" onClick={(e) => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.bomasTestLessonCount <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.bomasTestLessonCount > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.bomasTestLessonCount}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Lesson Name</Label>
            <Input className="form-control" type="text" placeholder='Enter Lesson Name' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && categoryNameValid() ? <span className='d-block font-danger'>{categoryNameValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Duration</Label>
            <Input className="form-control" type="text" placeholder='Enter Duration' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, duration: e.target.value }))} value={formVar.duration} />
            {submit && durationValid() ? <span className='d-block font-danger'>{durationValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle} >
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input id='radioinline1' type='radio' className="radio_animated" name='radio1' checked={stateStatus === 'active'} onChange={onValueChange} value='active' />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input id='radioinline3' type='radio' className="radio_animated" name='radio3' checked={stateStatus === 'pending'} onChange={onValueChange} value='pending' />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default BodmasTestLessonsTable;
